import { Type } from '@sinclair/typebox';
export const ListAccountSchema = Type.Object({
    number: Type.Integer(),
    name: Type.String(),
});
export const GetAccountsResponseSchema = Type.Array(ListAccountSchema);
